import {
  payment3_commonpb,
  payment3_paymentmethodpb,
} from "@ftdr/payment3_paymentmethod_coordinator-js-client";
import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
  useElements,
} from "@stripe/react-stripe-js";
import { useCallback } from "react";
import { useFormContext } from "react-hook-form";
import { usePaymentsClientContext } from "../../../../../../contexts/payments-client-context";
import {
  AgregatedProcessPaymentResponse,
  ProcessPaymentStripeRequestData,
  SuccessTypeValue,
} from "../../../../types";
import { StripeFormDetails } from "../../stripe-form";
import { createResultObject } from "../utils";
import { RetrieveSetupIntentReturnType } from "./use-retrive-setup-intent";
import { usePaymentContext } from "../../../../../../contexts/payment-context";
import { SetupIntent } from "@stripe/stripe-js";
import { getSaveInWallet } from "../../../../../../utils";

type HandleSavePaymentMethodType = (
  requestData: ProcessPaymentStripeRequestData | undefined,
  saveInWallet: boolean | undefined,
  setupIntentResponse: RetrieveSetupIntentReturnType,
  registrationID: string
) => Promise<AgregatedProcessPaymentResponse>;

type UseSavePaymentMethod = {
  handleSavePaymentMethod: HandleSavePaymentMethodType;
};

const convertPaymentMethodToPaymentMethodID = (
  paymentMethod?: SetupIntent["payment_method"]
) => {
  if (typeof paymentMethod === "string") {
    return paymentMethod;
  } else {
    return null;
  }
};
export const useSavePaymentMethod = (): UseSavePaymentMethod => {
  const { createPaymentMethod } = usePaymentsClientContext();
  const elements = useElements();
  const {
    applicationName,
    brand,
    owner,
    state: { isSetAsDefaultChecked, isSaveInWalletChecked },
    subbrand,
  } = usePaymentContext();
  const { reset } = useFormContext<StripeFormDetails>();

  const handleSavePaymentMethod = useCallback<HandleSavePaymentMethodType>(
    async (requestData, saveInWallet, setupIntentResponse, registrationID) => {
      //  STEP 5 Save stripe payment method id with selected client_secret and setup intent id
      // method will return FD payment method id
      const createPaymentMethodResult = await createPaymentMethod({
        registrationID,
        paymentMethod: {
          brand: brand,
          ...(subbrand ? { subbrand } : {}),
          source: applicationName ? { name: applicationName } : undefined,
          owner: owner ? owner : requestData?.stripe?.owner,
          includedInWallet: getSaveInWallet(
            isSetAsDefaultChecked,
            isSaveInWalletChecked,
            !!requestData?.stripe?.includedInWallet || saveInWallet
          ),
          processor: {
            processor: payment3_commonpb.PaymentProcessor.Stripe,
            stripe: {
              paymentMethodID: convertPaymentMethodToPaymentMethodID(
                setupIntentResponse?.result?.setupIntent?.payment_method
              ),
            },
          },
          details: {
            type: payment3_paymentmethodpb.PaymentMethodType.CreditCard,
          },
        },
      });
      if (
        createPaymentMethodResult?.success?.type ===
        SuccessTypeValue.STRIPE_SUCCESS
      ) {
        elements?.getElement(CardNumberElement)?.clear();
        elements?.getElement(CardExpiryElement)?.clear();
        elements?.getElement(CardCvcElement)?.clear();
        reset();
      }
      return createResultObject(createPaymentMethodResult);
    },
    [
      brand,
      createPaymentMethod,
      elements,
      isSaveInWalletChecked,
      isSetAsDefaultChecked,
      reset,
      applicationName,
      owner,
      subbrand,
    ]
  );

  return { handleSavePaymentMethod };
};
